function helperCreateToNumber (handle) {
  return function (str) {
    if (str) {
      var num = handle(str)
      if (!isNaN(num)) {
        return num
      }
    }
    return 0
  }
}

module.exports = helperCreateToNumber



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperCreateToNumber.js
// module id = kDIq
// module chunks = 141